import React, {useEffect, useState} from "react";
import {getTmdbImage} from "../../../../utils/consts";
import {
    cn,
    getAudioFromMetadata,
    getDurationFromMetadata,
    getSubtitlesFromMetadata,
    isMobileDevice
} from "../../../../utils/utils";
import CustomFilePlayer from "../customFilePlayer/customFilePlayer";
import {toast} from "react-toastify";
import {fetchEpisodeGroupDetails} from "../../api/cap17drive-api";
import './AIOStreamViewer.scss';
import {TorresstreamApi} from "../../../../apis/torrestream-api/torresstream-api";
import {AIOStreamAPI} from "../../../../apis/aiostream-api/aiostream-api";

const AIOStreamViewer = (props) => {

    const {type, squadFlixTvHook, tmdbId, season, episode, imagePath, item, onGoNextEpisode} = props;
    const [streamData, setStreamData] = useState(null);
    const [streamsLoading, setStreamsLoading] = useState(true);
    const [selectedStream, setSelectedStream] = useState(null);
    const [subtitles, setSubtitles] = useState([]);
    const [audios, setAudios] = useState([]);
    const [torrentRuntime, setTorrentRuntime] = useState(0);
    const [videoUrl, setVideoUrl] = useState(null);
    const [videoOriginalUrl, setVideoOriginalUrl] = useState(null);
    const loadedItem = React.useRef(undefined);
    const [onlyCached, setOnlyCached] = useState(false);
    const [expanded, setExpanded] = useState(false);

    useEffect(() => {
        if (!selectedStream) {
            setVideoUrl(null);
            setVideoOriginalUrl(null);
            setTorrentRuntime(item?.runtime ?? 0);
            setSubtitles([]);
            return;
        }

        setSubtitles([]);
        setAudios([]);
        setTorrentRuntime(0);

        TorresstreamApi.getFileUrlMetadata(selectedStream.url).then(res => {
            setTorrentRuntime(getDurationFromMetadata(res.metadata, item));
            setAudios(getAudioFromMetadata(res.metadata));
            setSubtitles(getSubtitlesFromMetadata(res.metadata));
        }).catch(err => {
            toast.error(err);
        });
        setVideoUrl(TorresstreamApi.get('streamRemoteFile').getUrl({fileUrl: selectedStream?.url}));
        setVideoOriginalUrl(selectedStream.url);
    }, [selectedStream]);

    const imdbId = props.item?.imdb_id || props.item?.external_ids?.imdb_id || props.item?.serie?.external_ids?.imdb_id;

    useEffect(() => {
        if (type === "tv") {
            if (!season || !episode) {
                setStreamsLoading(false);
                setStreamData([]);
                return;
            }

            fetchEpisodeGroupDetails(tmdbId, season, episode).then(data => {
                AIOStreamAPI.getSerieStreams(imdbId, data.season_number, data.episode_number).then(data => {
                    setStreamData(data?.streams ?? []);
                    setStreamsLoading(false);
                }).catch(err => {
                    setStreamsLoading(false);
                    toast.error("Error al cargar los streams. Culpa de Tebas.");
                });
            });

        } else {
            AIOStreamAPI.getMovieStreams(imdbId).then(data => {
                setStreamData(data?.streams ?? []);
                setStreamsLoading(false);
            }).catch(err => {
                setStreamsLoading(false);
                toast.error("Error al cargar los streams. Culpa de Tebas.");
            });
        }
    }, [type, imdbId, season, episode]);

    const handleCloseViewer = () => {
        setSelectedStream(null);
    }

    if (!selectedStream) {

        const cachedStreamsToggle = (className) =>
            (<button className={cn("aio-stream-viewer__option-btn", className)}
                     onClick={() => setOnlyCached(!onlyCached)}>
                {onlyCached ? <i className="fa-regular fa-square-check"></i> :
                    <i className="fa-regular fa-square"></i>}&nbsp;⚡
            </button>);

        return (
            <div className={cn("towersStreamViewer__torrents", {"aio-stream-viewer__torrents-expanded": expanded})}>
                <div className="towersStreamViewer__torrents__background">
                    {streamsLoading &&
                        <div
                            className="d-flex flex-column justify-content-center align-items-center ps-4 pe-4 text-center text-light">
                            <div className="spinner-border text-light" role="status">
                            </div>
                            <div>
                                Cargando resultados de AIOStreams
                            </div>
                            <div style={{
                                color: "rgb(255,255,255, 0.7)",
                            }}>
                                Esto puede tardar unos segundos
                            </div>
                        </div>}
                    {!streamsLoading && !streamData?.length &&
                        <div className="text-light">
                            No se encontraron Streams para este contenido
                        </div>
                    }
                    {!streamsLoading && !!streamData.length &&
                        <div className="towersStreamViewer__torrents__content">
                            <div className="towersStreamViewer__torrents__list">
                                {isMobileDevice() && <div className="d-flex justify-content-between" style={{
                                    padding: "0 10%"
                                }}>
                                    {cachedStreamsToggle()}
                                    <button className={"aio-stream-viewer__option-btn"}
                                            onClick={() => setExpanded(!expanded)}>
                                        {expanded ? <i className="fa-solid fa-compress"></i> :
                                            <i className="fa-solid fa-expand"></i>}
                                    </button>
                                </div>}
                                {!isMobileDevice() && cachedStreamsToggle("aio-stream-viewer__cache-toggle")}
                                <div className="towersStreamViewer__torrents__list__buttons">
                                    {streamData.map(torrent => {
                                        if (torrent.name.includes("⏳") && onlyCached) {
                                            return null;
                                        }

                                        return <button className="btn btn-outline-light"
                                                       style={{
                                                           display: "flex",
                                                           alignItems: "center",
                                                           gap: "20px",
                                                       }}
                                                       key={torrent.url}
                                                       onClick={() => setSelectedStream(torrent)}>
                                            <div style={{
                                                width: "75px",
                                            }}>
                                                {torrent.name}
                                            </div>
                                            <div style={{
                                                textAlign: "left",
                                            }} dangerouslySetInnerHTML={
                                                {__html: torrent?.description?.replace(/\n/g, "<br/>")}
                                            }></div>
                                        </button>
                                    })}
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>);
    }

    return (<CustomFilePlayer videoUrl={videoUrl} imagePath={getTmdbImage(imagePath)}
                              title={item.Title || item.name || item.original_title || item.original_name || "Video"}
                              onClosePlayer={handleCloseViewer} item={item}
                              onGoNextEpisode={onGoNextEpisode}
                              squadFlixTvHook={squadFlixTvHook}
                              audios={audios} subtitles={subtitles} customRuntime={torrentRuntime}
                              streaming={true} originalVideoUrl={videoOriginalUrl}/>);

}

export default AIOStreamViewer;
